import "./Coverimg.css";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useState, useEffect } from "react";
import { useUploadMultipleMutation } from "../../../../features/upload/uploadApiSlice";
import ImageCropDialog from "../../../../components/common/ImageCropDialog/ImageCropDialog";
import { useDropzone } from "react-dropzone";
import { FailedNotify } from "../../../../constants/tostify";
import { getAsset } from "../../../../helpers/helper";
import { useLocation } from "react-router-dom";
import { useUpdateUserProfileMutation } from "../../../../features/user/userApiSlice";

const Coverimg = ({ infooo, name, setInfooo }) => {

  const location = useLocation();
  const [isUploading, setIsUploading] = useState(false);
  const [updateProfile] = useUpdateUserProfileMutation();
  const [uploadMultiple] = useUploadMultipleMutation();
  const [cropOpen, setCropOpen] = useState(false);
  const [pendingFile, setPendingFile] = useState(null);
  const [imageError, setImageError] = useState(false);

  const coverSrc = infooo?.coverUrl?.[0]
    ? getAsset(infooo?.coverUrl[0])
    : null;

  useEffect(() => {
    setImageError(false);
  }, [infooo?.coverUrl?.[0]]);

  const onDrop = async (acceptedFiles) => {
    const file =
      acceptedFiles && acceptedFiles.length ? acceptedFiles[0] : null;
    if (file) {
      setPendingFile(file);
      setCropOpen(true);
    }
  };

  const handleCroppedAndUpload = async (blob) => {
    if (!blob || !pendingFile) return;
    setIsUploading(true);
    try {
      const croppedFile = new File([blob], pendingFile.name || "cropped.jpg", {
        type: blob.type,
      });
      const formData = new FormData();
      formData.append("images", croppedFile);

      const uploadRes = await uploadMultiple(formData).unwrap();

      if (uploadRes?.success || uploadRes?.message === "imagesSaved") {
        const extractImagePath = (f) => {
          if (!f) return null;
          if (typeof f === "string") {
            if (f.includes("undefined")) return null;
            return f.startsWith("/") ? f : "/images/" + f;
          }
          const fname = f?.filename || f?.name || (f?.url ? f.url.split("/").pop() : null);
          if (!fname || fname === "undefined") return null;
          return fname.startsWith("/") ? fname : "/images/" + fname;
        };

        const rawFiles = uploadRes?.file || uploadRes?.files || uploadRes?.urls || [];
        const abc = (Array.isArray(rawFiles) ? rawFiles : [rawFiles]).map(extractImagePath).filter(Boolean);

        const targetUserId = infooo?._id || name?._id;

        if (abc.length > 0 && targetUserId) {
          const response = await updateProfile({
            id: targetUserId,
            data: { coverUrl: abc },
          }).unwrap();

          if (response?.success && response?.data?.User) {
            setInfooo(response.data.User);
          }
        }
      } else {
        FailedNotify("Upload failed");
      }
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setCropOpen(false);
      setPendingFile(null);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: { 'image/*': [] },
    onDrop,
  });

  return (
    <>
      <Col sm="12" lg="12" md="12" className="Coverimage bg-btn-primary p-0">
        {coverSrc && !imageError ? (
          <img
            src={coverSrc}
            className="coverImgSize"
            alt="cover"
            loading="lazy"
            onError={() => setImageError(true)}
            onLoad={() => setImageError(false)}
          />
        ) : (
          <div
            className="coverImgSize w-100"
            style={{ backgroundColor: "blue" }}
            aria-hidden="true"
          ></div>
        )}

        {/* Loading spinner overlay — shown inside the cover image area during upload */}
        {isUploading && (
          <div className="cover-upload-overlay">
            <CircularProgress size={48} style={{ color: "#ffffff" }} />
            <span className="cover-upload-text">Uploading...</span>
          </div>
        )}
      </Col>

      <Row className="position_r">
        <Col
          lg="3"
          sm="5"
          className="Coverimage_dp p-0 smallWidth"
          name="coverUrl"
        >
          {location.pathname === "/user-profile" ? (
            <div {...getRootProps()} className="dropzone">
              <input {...getInputProps()} />
              <Button
                component="span"
                className="font_small text-dark"
                disabled={isUploading}
              >
                <CameraAltIcon style={{ color: "black" }} className="icon_f" />
                &nbsp;&nbsp; Add Cover Photo
              </Button>
            </div>
          ) : (
            ""
          )}
        </Col>
      </Row>
      <ImageCropDialog
        open={cropOpen}
        file={pendingFile}
        aspect={3}
        onClose={() => setCropOpen(false)}
        onCrop={handleCroppedAndUpload}
      />
    </>
  );
};
export default Coverimg;
